import { Users } from 'lucide-react-native';

import type { PeerSummary as PeerSummaryValue } from '../../model/types';
import { REPLY_DRAFT_COPY } from '../copy';
import { Disclosure } from '../shared/Disclosure';

import { HStack } from '@/components/ui/hstack';
import { Text } from '@/components/ui/text';
import { VStack } from '@/components/ui/vstack';

/** The brief joins peers' positions with a middle dot; each reads better on its own line. */
function peerPoints(text: string): string[] {
  return text
    .split(' · ')
    .map((point) => point.trim())
    .filter(Boolean);
}

/**
 * How peers answered similar cases, closed until asked for and placed after
 * the options, so it informs a decision rather than makes it.
 */
export function PeerSummary({ summary }: { summary: PeerSummaryValue }) {
  return (
    <Disclosure
      label={REPLY_DRAFT_COPY.peersHeading(summary.count)}
      icon={Users}
      testID="reply-draft-peers">
      <VStack className="gap-2">
        {peerPoints(summary.text).map((point, index) => (
          <HStack key={`${index}-${point}`} className="gap-2">
            <Text size="sm" className="text-typography-700" aria-hidden>
              •
            </Text>
            <Text size="sm" className="flex-1 text-typography-900">
              {point}
            </Text>
          </HStack>
        ))}
      </VStack>
    </Disclosure>
  );
}
